import { AttributesMixin, define, Model, type } from "@type-r/models";
import { DropdownFilter } from "../../components/search-bar/filters/dropdown-filter";
import { MultiSelectChipsAsyncFilter } from "../../components/search-bar/filters/multiselect-chips-async-filter";


export interface ValidationRuleFilters extends AttributesMixin<typeof ValidationRuleFilters> { }

@define
export class ValidationRuleFilters extends Model {
  
  static attributes = {
    filterAll: '',
    company: MultiSelectChipsAsyncFilter,
    assetType: type(DropdownFilter),
    status: type(DropdownFilter)
  }

  reset() {
    this.filterAll = '';
    this.company.$.selected.set([] as any);
    this.assetType.$.selected.set(0);
    this.status.$.selected.set(0);
  }
};
 